export const TEXTO = '#2a3547'
export const TEXTOCLARO = '#5a6a85'